import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { clearFiltersFromSession } from '../../../../utils';
import { unselectFilterCategoryOptions, clearFilterCategories } from '../../../../actions/searchActions';
import matomoTracker from '../../../../utils/matomo';

const ActiveFilters = ({
  filterCategory,
  filterProvider,
  unselectFilterCategoryOptions,
  clearFilterCategories,
  filteredPlans,
}) => {
  const buildOtherParams = (searchParams, excludeKeys = []) =>
    searchParams.filter((p) => !excludeKeys.some((k) => p.includes(`${k}=`)) && p !== '');

  const replaceUrl = (paramsArray) => {
    const location = paramsArray.length > 0 ? `?${paramsArray.join('&')}` : window.location.pathname;
    window.history.replaceState(null, null, location);
  };

  const removeValueFromParam = (key, value) => {
    const searchParams = window.location.search.replace('?', '').split('&');
    let newParam = searchParams.find((param) => param.includes(`${key}=`)) || '';

    if (newParam) {
      if (newParam === `${key}=${value}`) {
        newParam = '';
      } else if (newParam.endsWith(`,${value}`)) {
        newParam = newParam.replace(`,${value}`, '');
      } else if (newParam.startsWith(`${key}=${value},`)) {
        newParam = newParam.replace(`${value},`, '');
      } else {
        newParam = newParam.replace(`${value},`, '');
        newParam = newParam.replace(`,${value}`, '');
      }
    }

    const otherParams = buildOtherParams(searchParams, [key]);
    const allParams = newParam ? [...otherParams, newParam] : otherParams;
    replaceUrl(allParams);
  };

  const selectedCategories = filterCategory.flatMap((category, categoryIndex) =>
    category.Categories.map(
      (option, optionIndex) =>
        option.selected && {
          key: `${categoryIndex}-${optionIndex}`,
          name: option.Name,
          unselect: () => {
            removeValueFromParam('category', option.ID);
            unselectFilterCategoryOptions('category', categoryIndex, optionIndex);
          },
        }
    ).filter(Boolean)
  );

  const selectedProviders = filterProvider
    .filter((provider) => provider.selected)
    .map((provider) => ({
      key: `provider-${provider.id}`,
      name: provider.name,
      unselect: () => {
        removeValueFromParam('provider', provider.slug);
        unselectFilterCategoryOptions(
          'provider',
          filterProvider.findIndex((prov) => prov.id === provider.id)
        );
      },
    }));

  const hasSelectedFilters = selectedCategories.length > 0 || selectedProviders.length > 0;

  useEffect(() => {
    const activeFilters = {
      providers: selectedProviders.map(p => p.name),
      benefits: selectedCategories.map(c => c.name),
    };
    const filteredPlans_count = filteredPlans.length
    matomoTracker.trackFilters(activeFilters, filteredPlans_count);
  }, [filterCategory, filterProvider, filteredPlans]);

  const HandleClearAll = () => {
    clearFiltersFromSession();

    const searchParams = window.location.search.replace('?', '').split('&');
    const otherParams = buildOtherParams(searchParams, ['category', 'provider']);
    replaceUrl(otherParams);
    clearFilterCategories();
  };

  return hasSelectedFilters ? (
    <div className="selected-filters-container">
      <div className="filtros-selecionados">
        <span>Filtros Aplicados</span>
        <button onClick={HandleClearAll}>Limpar todos</button>
      </div>
      <ul className={`ul-filtros-selecionados`} id="active-filters-list">
        {selectedCategories.concat(selectedProviders).map(({ key, name, unselect }) => (
          <li key={key}>
            <span>{name}</span>
            <button onClick={unselect}>
              <img src="/assets/images/x_branco.svg" alt="remover filtro" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default connect(
  (state) => ({
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    filteredPlans: state.search.filtered_plans,
  }),
  {
    unselectFilterCategoryOptions,
    clearFilterCategories,
  }
)(ActiveFilters);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/Filters/ActiveFilters.jsx